import { useMemo } from 'react';
import type { MKEERAApiResponseItem } from '../dashboard.types';

export function useGenderPercentages(data: MKEERAApiResponseItem[]) {
  return useMemo(() => {
    // Safety check: ensure data is an array
    if (!Array.isArray(data) || data.length === 0) {
      return { male: 0, female: 0, declined: 0 };
    }

    const counts = data.reduce(
      (acc, item) => {
        const gender = item.applicationData.gender?.toLowerCase();
        if (gender === 'male') acc.male++;
        else if (gender === 'female') acc.female++;
        else acc.declined++;
        return acc;
      },
      { male: 0, female: 0, declined: 0 }
    );
    const total = counts.male + counts.female + counts.declined;
    if (total === 0) return { male: 0, female: 0, declined: 0 };

    // Calculate percentages with proper rounding
    const female = Math.round((counts.female / total) * 100);
    const male = Math.round((counts.male / total) * 100);
    const declined = 100 - female - male;

    return { male, female, declined };
  }, [data]);
}
